import React from "react";
import { useNavigate } from "react-router";

function BackBtn(props: any) {
  const navigate = useNavigate();
  return (
 <button
  className={`button backbutton circle d-flex justify-content-center align-items-center ${
    props.backTo === "quality-control" || props.backTo === "client-ready"
      ? "back-btn-reduce"
      : ""
  }`}
  onClick={() =>
    props.backTo === "quality-control"
      ? navigate("/documents?view=quality-control")
      : window.location.replace("/auth/inprogress")
  }
>
  <span className="material-symbols-outlined">arrow_back</span>
</button>
  );
}

export default BackBtn;
